angular.module('unica_workshop_session.workshop_session_services')

.factory('WorkshopSessionDeleteService', function ($http, getBaseApiURL) {

	var workshopSessionDeleteService = {};

	workshopSessionDeleteService.delete = function (workshopSessionId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/workshop-session/delete/' + workshopSessionId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return workshopSessionDeleteService;
});